import React from 'react';
import { connect } from 'react-redux';

export class FieldAccess extends React.Component {
    render() {
        const access = parseInt(this.props.access);
        return this.props.fieldAccess && this.props.fieldAccess >= access ? this.props.children : <div display="none"></div>;

    }
}

function mapStateToProps(state, ownProps) {
    if (ownProps.fieldName)
        return {
            fieldAccess: ownProps.fieldName && ownProps.fieldName !== ""
                ? state.app.appFieldsAccess[ownProps.fieldName]
                : false
        };
};


export default connect(mapStateToProps)(FieldAccess);